var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('UIHeader',{attrs:{"critical":true}}),_vm._v(" "),_c('CartBannerTop'),_vm._v(" "),_c('div',{staticClass:"content-area",attrs:{"id":"primaryhome"}},[_c('main',{staticClass:"site-main",attrs:{"id":"main","role":"main"}},[_c('Nuxt')],1)]),_vm._v(" "),_c('LazyUIFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }